import { render, staticRenderFns } from "./ProjectMembersAvatarList.vue?vue&type=template&id=09ce6e8e&"
import script from "./ProjectMembersAvatarList.vue?vue&type=script&lang=js&"
export * from "./ProjectMembersAvatarList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMembersAvatarList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports